import {
  Box,
  Button,
  Text,
  PinInput,
  PinInputField,
  HStack,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
} from '@chakra-ui/react'
import React, { useState } from 'react'

type EnterRoomReservationModalProps = {
  isOpen: boolean
  onClose: () => void
  onEnter: (password: string) => void
  error?: string
}

const EnterRoomReservationModal: React.FC<EnterRoomReservationModalProps> = ({ isOpen, onClose, onEnter, error }) => {
  const [pin, setPin] = useState('')
  const [inputError, setInputError] = useState<string | null>(null)

  const handleComplete = (value: string) => {
    if (!/^\d{6}$/.test(value)) {
      setInputError('6桁の数字を入力してください')
      return
    }
    setInputError(null)
    onEnter(value)
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader textAlign="center">パスワードを入力してください</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box textAlign="center" py={2}>
            <HStack justify="center" mb={2}>
              <PinInput
                type="number"
                mask
                otp
                value={pin}
                onChange={setPin}
                size="lg"
                placeholder=""
              >
                <PinInputField inputMode="numeric" />
                <PinInputField inputMode="numeric" />
                <PinInputField inputMode="numeric" />
                <PinInputField inputMode="numeric" />
                <PinInputField inputMode="numeric" />
                <PinInputField inputMode="numeric" />
              </PinInput>
            </HStack>
            {(inputError || error) && (
              <Text color="red.500" mb={2}>{inputError || error}</Text>
            )}
          </Box>
        </ModalBody>
        <ModalFooter flexDirection="column" gap={2}>
          <Button colorScheme="primary" w="100%" onClick={() => handleComplete(pin)}>
            入室
          </Button>
          <Button variant="ghost" w="100%" onClick={onClose}>
            閉じる
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

export default EnterRoomReservationModal
